var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-modal', {
    attrs: {
      "centered": "",
      "size": "md",
      "title": "Filter Data",
      "ok-title": "Filter"
    },
    on: {
      "ok": _vm.fetchData
    },
    model: {
      value: _vm.showModalFilter,
      callback: function callback($$v) {
        _vm.showModalFilter = $$v;
      },
      expression: "showModalFilter"
    }
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "b-label"
  }, [_vm._v("Date")])]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('date-picker', {
    staticClass: "mr-2 w-100",
    model: {
      value: _vm.filterDate,
      callback: function callback($$v) {
        _vm.filterDate = $$v;
      },
      expression: "filterDate"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', {
    staticClass: "b-label"
  }, [_vm._v("Status")])]), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('v-multiselect', {
    attrs: {
      "multiple": true,
      "label": "name",
      "track-by": "value",
      "options": _vm.statusOptions
    },
    model: {
      value: _vm.statusSelected,
      callback: function callback($$v) {
        _vm.statusSelected = $$v;
      },
      expression: "statusSelected"
    }
  })], 1)], 1)], 1), _c('b-sidebar', {
    attrs: {
      "right": "",
      "width": "50%",
      "bg-variant": "white",
      "title": "Add New Running Hours",
      "header-class": "p-0",
      "shadow": "",
      "backdrop": ""
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "w-100 p-2 px-3 d-flex justify-content-between align-items-center",
          staticStyle: {
            "border-bottom": "1px solid #ced4da",
            "font-size": "18px",
            "font-weight": "600"
          }
        }, [_c('i', {
          staticClass: "fa fa-close cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showCanvas = false;
            }
          }
        }), _c('p', {
          staticClass: "m-0"
        }, [_vm._v(_vm._s(_vm.selectedData ? 'Detail' : 'Create') + " Adjusment Running Hours")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showCanvas,
      callback: function callback($$v) {
        _vm.showCanvas = $$v;
      },
      expression: "showCanvas"
    }
  }, [[_vm.showCanvas ? _c('FormAdjustmentRunningHours', {
    attrs: {
      "selectedData": _vm.selectedData
    },
    on: {
      "refetch": _vm.fetchData,
      "close": function close($event) {
        _vm.showCanvas = false;
      }
    }
  }) : _vm._e()]], 2), _c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("ADJUSTMENT RUNNING HOURS")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$adjustments, _vm$adjustments$data;
        return [_c('b-row', [_c('b-col', {
          staticClass: "mb-3 d-flex",
          attrs: {
            "md": "6"
          }
        }, [_c('div', {
          staticClass: "d-flex"
        }, [_c('b-input', {
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "placeholder": "Search.."
          },
          model: {
            value: _vm.filterSearch,
            callback: function callback($$v) {
              _vm.filterSearch = $$v;
            },
            expression: "filterSearch"
          }
        }), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.fetchData
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })])], 1), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalFilter = true;
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-sliders"
        }), _vm._v(" Filter Data")])], 1), _c('b-col', {
          staticClass: "d-flex justify-content-end",
          attrs: {
            "md": "6"
          }
        }, [_c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              ;
              _vm.showCanvas = true, _vm.selectedData = null;
            }
          }
        }, [_vm._v("Create Adjustment Running Hours")])], 1), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "w-100 table-striped"
        }, [_c('thead', [_c('th', [_vm._v("FLEET ")]), _c('th', [_vm._v("TRANSACTION ID")]), _c('th', [_vm._v("CREATOR BY")]), _c('th', [_vm._v("EFFECTIVE DATE")]), _c('th', [_vm._v("STATUS")]), _c('th', [_vm._v("ACTION")])]), !_vm.loading ? _c('tbody', [_vm._l(_vm.adjustments.data, function (item, i) {
          var _item$vehicle, _item$user, _item$user$requestor, _item$user2, _item$user2$requestor, _item$user3, _item$user3$detail, _item$user3$detail$de, _item$effective_date;
          return [_c('tr', {
            key: "".concat(i)
          }, [_c('td', [_c('b-badge', {
            attrs: {
              "variant": "success"
            }
          }, [_vm._v(_vm._s((_item$vehicle = item.vehicle) === null || _item$vehicle === void 0 ? void 0 : _item$vehicle.name))])], 1), _c('td', [_vm._v("TRX-ADJSRH-" + _vm._s(item === null || item === void 0 ? void 0 : item.id) + "-" + _vm._s(item !== null && item !== void 0 && item.effective_date ? _vm.moment(item === null || item === void 0 ? void 0 : item.effective_date).format('MMYYYY') : ''))]), _c('td', [_c('UserTemplate', {
            attrs: {
              "userDetail": {
                name: item === null || item === void 0 ? void 0 : (_item$user = item.user) === null || _item$user === void 0 ? void 0 : (_item$user$requestor = _item$user.requestor) === null || _item$user$requestor === void 0 ? void 0 : _item$user$requestor.name,
                photo: item === null || item === void 0 ? void 0 : (_item$user2 = item.user) === null || _item$user2 === void 0 ? void 0 : (_item$user2$requestor = _item$user2.requestor) === null || _item$user2$requestor === void 0 ? void 0 : _item$user2$requestor.photo,
                position: item === null || item === void 0 ? void 0 : (_item$user3 = item.user) === null || _item$user3 === void 0 ? void 0 : (_item$user3$detail = _item$user3.detail) === null || _item$user3$detail === void 0 ? void 0 : (_item$user3$detail$de = _item$user3$detail.department) === null || _item$user3$detail$de === void 0 ? void 0 : _item$user3$detail$de.name
              }
            }
          })], 1), _c('td', [_vm._v(_vm._s((_item$effective_date = item === null || item === void 0 ? void 0 : item.effective_date) !== null && _item$effective_date !== void 0 ? _item$effective_date : '-'))]), _c('td', [_c('b-alert', {
            staticClass: "p-0 m-0 text-capitalize d-flex justify-content-center",
            staticStyle: {
              "width": "100px",
              "border-radius": "4px"
            },
            attrs: {
              "show": "",
              "variant": _vm.getVariant(item === null || item === void 0 ? void 0 : item.state)
            }
          }, [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.state))])], 1), _c('td', {
            staticStyle: {
              "width": "120px"
            }
          }, [_c('b-dropdown', {
            attrs: {
              "text": "Action",
              "size": "sm",
              "variant": "outline-primary"
            }
          }, [_c('b-dropdown-item', {
            on: {
              "click": function click() {
                _vm.showCanvas = true;
                _vm.selectedData = item;
              }
            }
          }, [_vm._v(" View Detail Transaction")]), _c('b-dropdown-item', {
            on: {
              "click": function click($event) {
                return _vm.handleDelete(item);
              }
            }
          }, [_vm._v(" Delete Transaction")]), (item === null || item === void 0 ? void 0 : item.state) == 'requested' ? [_c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleConfirm(item, 'approve');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-thumbs-up text-success mr-1"
          }), _vm._v(" Approved")]), _c('b-dropdown-item', {
            on: {
              "click": function click() {
                return _vm.handleConfirm(item, 'reject');
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-close text-danger mr-2"
          }), _vm._v(" Rejected")])] : _vm._e()], 2)], 1)])];
        })], 2) : _vm._e()]), _vm.loading ? _c('div', {
          staticClass: "w-100 d-flex justify-content-center py-5"
        }, [_c('b-spinner')], 1) : _vm._e(), !_vm.loading && !((_vm$adjustments = _vm.adjustments) !== null && _vm$adjustments !== void 0 && (_vm$adjustments$data = _vm$adjustments.data) !== null && _vm$adjustments$data !== void 0 && _vm$adjustments$data.length) ? _c('div', {
          staticClass: "w-100 d-flex justify-content-center py-4"
        }, [_vm._v(" No Data Here! ")]) : _vm._e()])], 1)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }